import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import React, { forwardRef, useEffect, useImperativeHandle } from "react";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
	root: {
		"& > *": {
			margin: theme.spacing(1),
			width: "25ch",
		},
	},
}));

const PaymentForm = forwardRef((props, ref) => {
	const classes = useStyles();
	const state = useSelector((state) => state);
	const [checked, setChecked] = React.useState({
		cashOption: true,
		mobileOption: false,
		cardOption: false,
		TermsAndCondition: false,
	});
	const [currency, setCurrency] = React.useState("RWF");
	const [paymentCond, setPaymentCond] = React.useState(false);
	const [inputs, setInputs] = React.useState({
		action: "update_Payment",
		paymentType: checked.cashOption
			? "cash"
			: checked.mobileOption
			? "MobileMoney"
			: checked.cardOption
			? "card"
			: "",
		currency: currency,
		amountPaid: state.order.order.totalCost,
	});

	const handleChange = (event) => {
		console.log("handleChange event.target.name=", event.target.name);
		let checkedTmp = checked;

		if (event.target.name !== "TermsAndCondition")
			checkedTmp = {
				cashOption: false,
				mobileOption: false,
				cardOption: false,
			};
		setChecked({
			...checkedTmp,
			[event.target.name]:
				event.target.name === "TermsAndCondition" ? event.target.checked : true,
		});
	};
	const handleOpenTerms = () => {
		console.log("handleOpenTerms clicked");
	};
	useImperativeHandle(ref, () => {
		return { paymentInputs: inputs, paymentCond: paymentCond };
	});

	useEffect(() => {
		console.log("PaymentForm checked=", checked);
		if (checked.TermsAndCondition) {
			setPaymentCond(true);
		}
	}, [checked, setChecked]);
	return (
		<React.Fragment>
			<Typography variant="h6" gutterBottom>
				Payment method
			</Typography>
			<FormControl component="fieldset">
				<FormGroup aria-label="position" row>
					<FormControlLabel
						value="Cash"
						control={
							<Checkbox
								name="cashOption"
								color="primary"
								checked={checked.cashOption}
								onChange={handleChange}
							/>
						}
						label="Cash"
						labelPlacement="top"
					/>
					<FormControlLabel
						value="Mobile"
						control={
							<Checkbox
								name="mobileOption"
								color="primary"
								checked={checked.mobileOption}
								onChange={handleChange}
							/>
						}
						label="Mobile"
						labelPlacement="top"
					/>
					<FormControlLabel
						value="Card"
						control={
							<Checkbox
								name="cardOption"
								color="primary"
								checked={checked.cardOption}
								onChange={handleChange}
							/>
						}
						label="Card"
						labelPlacement="top"
					/>
				</FormGroup>
			</FormControl>
			<TextField
				fullWidth
				id="standard-select-currency"
				select
				label="Currency"
				value={currency}
				onChange={handleChange}
				helperText="Please select your currency"
			>
				<MenuItem key="RWF" value="RWF">
					RWF
				</MenuItem>
			</TextField>
			{checked.cashOption && (
				<>
					<form className={classes.root} noValidate autoComplete="off">
						<TextField
							disabled={true}
							id="amountPaid"
							name="amountPaid"
							defaultValue={state.order.order.totalCost}
							label="Amount"
							variant="outlined"
						/>
					</form>
				</>
			)}
			{checked.mobileOption && (
				<>
					<form className={classes.root} noValidate autoComplete="off">
						<TextField
							id="mobileNumber"
							label="mobile Number"
							variant="outlined"
						/>
					</form>
				</>
			)}
			{checked.cardOption && (
				<Grid container spacing={3}>
					<Grid item xs={12} md={6}>
						<TextField
							required
							id="cardName"
							label="Name on card"
							fullWidth
							autoComplete="cc-name"
						/>
					</Grid>
					<Grid item xs={12} md={6}>
						<TextField
							required
							id="cardNumber"
							label="Card number"
							fullWidth
							autoComplete="cc-number"
						/>
					</Grid>
					<Grid item xs={12} md={6}>
						<TextField
							required
							id="expDate"
							label="Expiry date"
							fullWidth
							autoComplete="cc-exp"
						/>
					</Grid>
					<Grid item xs={12} md={6}>
						<TextField
							required
							id="cvv"
							label="CVV"
							helperText="Last three digits on signature strip"
							fullWidth
							autoComplete="cc-csc"
						/>
					</Grid>
					<Grid item xs={12}>
						<FormControlLabel
							control={
								<Checkbox color="secondary" name="saveCard" value="yes" />
							}
							label="Remember credit card details for next time"
						/>
					</Grid>
				</Grid>
			)}

			<FormControlLabel
				value="Terms"
				control={
					<Checkbox
						name="TermsAndCondition"
						color="primary"
						checked={checked.TermsAndCondition}
						onChange={handleChange}
					/>
				}
				label="I have read and Accept Terms & Conditions"
				labelPlacement="left"
				onClick={handleOpenTerms}
			/>
		</React.Fragment>
	);
});
export default PaymentForm;
